import React from "react";
import { motion } from "framer-motion";

// List of tech stack icons
const techStacks = [
  { name: "Python", src: "/assets/python.svg" },
  { name: "React", src: "/assets/react.svg" },
  { name: "Docker", src: "/assets/docker.svg" },
  { name: "Flask", src: "/assets/flask.svg", dark: true },
  { name: "Django", src: "/assets/django.svg" },
  { name: "JavaScript", src: "/assets/javascript.svg" },
  { name: "Node.js", src: "/assets/nodejs.svg" },
  { name: "MongoDB", src: "/assets/mongodb.svg" },
  { name: "PostgreSQL", src: "/assets/postgresql.svg" },
  { name: "Azure", src: "/assets/azure.svg" },
  { name: "TensorFlow", src: "/assets/tensorflow.svg", dark: true },
  { name: "FastAPI", src: "/assets/fastapi.svg", dark: true },
  { name: "MYSQL", src: "/assets/mysql.svg" },
  { name: "Langchain", src: "/assets/LangChain.png" },
  { name: "OpenCV", src: "/assets/opencv.svg" },
  { name: "Pandas", src: "/assets/pandas.svg" },
  { name: "Numpy", src: "/assets/numpy.svg" },
  { name: "Jira", src: "/assets/jira.svg" },
  { name: "Yolo", src: "/assets/yolo.png" },
  { name: "Ollama", src: "/assets/ollama.png" },
  { name: "PyTorch", src: "/assets/pytorch.svg" },
  { name: "NextJS", src: "/assets/nextjs.svg" , dark: true},

];

// Floating animation settings (Fixed)
const floatingAnimation = {
  y: [0, 15, 0], // Up and down motion
  transition: {
    duration: 5,
    repeat: Infinity,
    repeatType: "reverse", // ✅ FIXED: "reverse" instead of "mirror"
    ease: "easeInOut",
  },
};

const TechStackSection = () => {
  return (
    <section className="relative min-h-screen text-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden flex flex-col items-center">
      {/* Section Title */}
      <div className="text-center mb-16">
        <h2 className="text-4xl sm:text-5xl font-bold text-white bg-clip-text text-transparent">
          Tech Stacks I Use
        </h2>
        <p className="text-xl text-gray-400 max-w-3xl mx-auto">
          Technologies I work with daily to build scalable, high-performance applications.
        </p>
      </div>

      {/* Floating Tech Stack Icons */}
      <div className="relative flex flex-wrap justify-center gap-10 w-full max-w-5xl">
        {techStacks.map((tech, index) => (
          <motion.div
            key={index}
            className="relative flex items-center justify-center w-24 h-24"
            animate={{ y: [0, 15, 0] }} // Apply smooth floating animation inline
            transition={{
              duration: 5,
              repeat: Infinity,
              repeatType: "reverse", // ✅ FIXED: Now works properly
              ease: "easeInOut",
            }}
            whileHover={{ scale: 1.2 }}
          >
            <img
              src={tech.src}
              alt={tech.name}
              className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 opacity-90 hover:opacity-100 transition-opacity duration-300"
              style={{ filter: tech.dark ? "invert(1) brightness(1.2)" : "none" }} // Fix for dark icons
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default TechStackSection;


// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";

// // List of tech stack icons
// const techStacks = [
//   { name: "Python", src: "/assets/python.svg" },
//   { name: "React", src: "/assets/react.svg" },
//   { name: "Docker", src: "/assets/docker.svg" },
//   { name: "Flask", src: "/assets/flask.svg", dark: true },
//   { name: "Django", src: "/assets/django.svg" },
//   { name: "JavaScript", src: "/assets/javascript.svg" },
//   { name: "Node.js", src: "/assets/nodejs.svg" },
//   { name: "MongoDB", src: "/assets/mongodb.svg" },
//   { name: "PostgreSQL", src: "/assets/postgresql.svg" },
//   { name: "Azure", src: "/assets/azure.svg" },
//   { name: "TensorFlow", src: "/assets/tensorflow.svg", dark: true },
//   { name: "FastAPI", src: "/assets/fastapi.svg", dark: true },
// ];

// // Function to generate a non-overlapping random position
// const generateNonOverlappingPositions = (count: number, minDistance = 80) => {
//   let positions: { top: number; left: number }[] = [];

//   while (positions.length < count) {
//     let newPos = {
//       top: Math.random() * 80 + 10, // Ensure it stays within bounds
//       left: Math.random() * 80 + 10,
//     };

//     // Check for overlap
//     if (
//       !positions.some(
//         (pos) =>
//           Math.abs(pos.top - newPos.top) < minDistance &&
//           Math.abs(pos.left - newPos.left) < minDistance
//       )
//     ) {
//       positions.push(newPos);
//     }
//   }

//   return positions;
// };

// // const TechStackSection = () => {
// //   const [iconPositions, setIconPositions] = useState(generateNonOverlappingPositions(techStacks.length));

// //   useEffect(() => {
// //     const interval = setInterval(() => {
// //       setIconPositions(generateNonOverlappingPositions(techStacks.length));
// //     }, 5000); // Change positions every 5 seconds smoothly

// //     return () => clearInterval(interval);
// //   }, []);

// //   return (
// //     <section className="relative min-h-screen bg-black text-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden flex justify-center items-center">
// //       {/* Section Title */}
// //       <div className="absolute top-10 text-center w-full">
// //         <h2 className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-white via-gray-400 to-white bg-clip-text text-transparent">
// //           Tech Stacks I Use
// //         </h2>
// //         <p className="text-xl text-gray-400 max-w-3xl mx-auto">
// //           Technologies I work with daily to build scalable, high-performance applications.
// //         </p>
// //       </div>

// //       {/* Floating Tech Stack Icons */}
// //       <div className="relative w-full h-[600px]">
// //         {techStacks.map((tech, index) => (
// //           <motion.div
// //             key={index}
// //             className="absolute"
// //             initial={{ top: `${iconPositions[index].top}%`, left: `${iconPositions[index].left}%` }}
// //             animate={{ top: `${iconPositions[index].top}%`, left: `${iconPositions[index].left}%` }}
// //             transition={{ duration: 2, ease: "easeInOut" }}
// //             whileHover={{ scale: 1.2 }}
// //           >
// //             <motion.img
// //               src={tech.src}
// //               alt={tech.name}
// //               animate={{
// //                 y: [0, Math.random() * 15 - 7.5, 0], // Subtle floating effect
// //                 x: [0, Math.random() * 15 - 7.5, 0],
// //                 rotate: [0, Math.random() * 5 - 2.5, 0],
// //                 transition: {
// //                   duration: Math.random() * 4 + 3,
// //                   repeat: Infinity,
// //                   repeatType: "mirror", // Ensures smooth looping
// //                   ease: "easeInOut",
// //                 },
// //               }}
// //               className={`w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 opacity-90 hover:opacity-100 transition-opacity duration-300`}
// //               style={{ filter: tech.dark ? "invert(1) brightness(1.2)" : "none" }} // Fix for dark icons
// //             />
// //           </motion.div>
// //         ))}
// //       </div>
// //     </section>
// //   );
// // };

// // export default TechStackSection;


// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";

// // List of tech stack icons
// const techStacks = [
//   { name: "Python", src: "/assets/python.svg" },
//   { name: "React", src: "/assets/react.svg" },
//   { name: "Docker", src: "/assets/docker.svg" },
//   { name: "Flask", src: "/assets/flask.svg", dark: true },
//   { name: "Django", src: "/assets/django.svg" },
//   { name: "JavaScript", src: "/assets/javascript.svg" },
//   { name: "Node.js", src: "/assets/nodejs.svg" },
//   { name: "MongoDB", src: "/assets/mongodb.svg" },
//   { name: "PostgreSQL", src: "/assets/postgresql.svg" },
//   { name: "Azure", src: "/assets/azure.svg" },
//   { name: "TensorFlow", src: "/assets/tensorflow.svg", dark: true },
//   { name: "FastAPI", src: "/assets/fastapi.svg", dark: true },
// ];

// // Function to generate smooth floating animation
// const generateFloatingAnimation = () => ({
//   y: [0, Math.random() * 20 - 10, 0], // Subtle up and down motion
//   x: [0, Math.random() * 20 - 10, 0], // Slight left and right motion
//   rotate: [0, Math.random() * 10 - 5, 0], // Subtle rotation
//   transition: {
//     duration: Math.random() * 5 + 3,
//     repeat: Infinity,
//     repeatType: "mirror" as "mirror", // Explicitly casting repeatType
//     ease: "easeInOut",
//   },
// });

// // Function to generate random positions
// const generateRandomPosition = () => ({
//   top: `${Math.random() * 80 + 10}%`,
//   left: `${Math.random() * 80 + 10}%`,
// });

// const TechStackSection = () => {
//   const [iconPositions, setIconPositions] = useState(
//     techStacks.map(() => generateRandomPosition())
//   );

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIconPositions(techStacks.map(() => generateRandomPosition()));
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <section className="relative min-h-screen bg-black text-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden flex justify-center items-center">
//       {/* Section Title */}
//       <div className="absolute top-10 text-center w-full">
//         <h2 className="text-4xl sm:text-5xl font-bold bg-gradient-to-r from-white via-gray-400 to-white bg-clip-text text-transparent">
//           Tech Stacks I Use
//         </h2>
//         <p className="text-xl text-gray-400 max-w-3xl mx-auto">
//           Technologies I work with daily to build scalable, high-performance applications.
//         </p>
//       </div>

//       {/* Floating Tech Stack Icons */}
//       <div className="relative w-full h-[600px]">
//         {techStacks.map((tech, index) => (
//           <motion.div
//             key={index}
//             className="absolute"
//             initial={iconPositions[index]}
//             animate={iconPositions[index]}
//             transition={{ duration: 2, ease: "easeInOut" }}
//             whileHover={{ scale: 1.2 }}
//           >
//             <motion.img
//               src={tech.src}
//               alt={tech.name}
//               animate={{
//                 y: [0, Math.random() * 15 - 7.5, 0], // Subtle floating effect
//                 x: [0, Math.random() * 15 - 7.5, 0],
//                 rotate: [0, Math.random() * 5 - 2.5, 0],
//                 transition: {
//                   duration: Math.random() * 4 + 3,
//                   repeat: Infinity,
//                   repeatType: "mirror", // Correct TypeScript usage
//                   ease: "easeInOut",
//                 },
//               }}
//               className={`w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 opacity-90 hover:opacity-100 transition-opacity duration-300`}
//               style={{ filter: tech.dark ? "invert(1) brightness(1.2)" : "none" }} // Fix for dark icons
//             />
//           </motion.div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default TechStackSection;


// import React from "react";
// import { motion } from "framer-motion";

// // List of tech stack icons
// const techStacks = [
//   { name: "Python", src: "/assets/python.svg" },
//   { name: "React", src: "/assets/react.svg" },
//   { name: "Docker", src: "/assets/docker.svg" },
//   { name: "Flask", src: "/assets/flask.svg" },
//   { name: "Django", src: "/assets/django.svg" },
//   { name: "JavaScript", src: "/assets/javascript.svg" },
//   { name: "Node.js", src: "/assets/nodejs.svg" },
//   { name: "MongoDB", src: "/assets/mongodb.svg" },
//   { name: "PostgreSQL", src: "/assets/postgresql.svg" },
//   { name: "Azure", src: "/assets/azure.svg" },
//   { name: "TensorFlow", src: "/assets/tensorflow.svg" },
//   { name: "FastAPI", src: "/assets/fastapi.svg" },
// ];

// // Function to generate smooth floating animation
// const generateRandomAnimation = () => ({
//   y: [0, Math.random() * 30 - 15, 0], // Subtle up and down motion
//   x: [0, Math.random() * 30 - 15, 0], // Slight left and right motion
//   rotate: [0, Math.random() * 10 - 5, 0], // Subtle rotation
//   transition: {
//     duration: Math.random() * 6 + 3, // Random duration between 3 to 9 seconds
//     repeat: Infinity,
//     repeatType: "mirror" as "mirror", // Ensures a smooth loop
//     ease: "easeInOut",
//   },
// });

// const TechStackSection = () => {
//   return (
//     <section className="relative min-h-screen text-white py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
//       {/* Background Glow Effect */}
//       <div className="absolute inset-0 " />

//       {/* Section Title */}
//       <div className="text-center mb-40 relative">
//         <h2 className="text-4xl sm:text-5xl bg-gradient-to-r from-white via-gray-400 to-white bg-clip-text text-transparent">
//           Tech Stacks
//         </h2>
//         <p className="text-xl text-gray-400 max-w-3xl mx-auto">
//           A collection of technologies I work with daily to build scalable, high-performance applications.
//         </p>
//       </div>

//       {/* Floating Tech Stack Icons Grid */}
//       <div className="relative grid grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-10 max-w-5xl mx-auto">
//         {techStacks.map((tech, index) => (
//           <motion.div
//             key={index}
//             className="relative flex items-center justify-center w-24 h-24"
//             animate={generateRandomAnimation()} // Apply floating animation
//           >
//             <img
//               src={tech.src}
//               alt={tech.name}
//               className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 opacity-80 hover:opacity-100 transition-opacity duration-300"
//             />
//           </motion.div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default TechStackSection;
